import type { UseMutationOptions } from '@tanstack/react-query';
import { mutationOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';

import type { BnplIntentPayload, BnplIntentResponse } from './types';

async function createBnplIntent(
  payload: BnplIntentPayload,
): Promise<BnplIntentResponse> {
  const { data } = await apiClient.post<BnplIntentResponse>(
    '/v1/payment/bnpl-intent',
    payload,
  );
  return data;
}

export const bnplIntentMutation = (
  options?: UseMutationOptions<BnplIntentResponse, Error, BnplIntentPayload>,
) =>
  mutationOptions({
    mutationFn: createBnplIntent,
    mutationKey: ['bnplIntent'],
    retry: false,
    ...options,
  });
